<template>
  <div id="pageContent" class="fans-layout">
    <TopBanner :bg-img="bgImg" :main-title="mainTitle"
               :class="{mobile : isMobile && currentMenuName.includes('fansDetail')}"
               :sub-title="!isEmpty(subTitle) ? subTitle : routeName" />
    <router-view class="contents"></router-view>
  </div>
</template>

<script>
import TopBanner from '@/components/Common/TopBanner.vue';
import {isEmpty} from '@/lib';

export default {
  name: 'FansLayout',
  components: {
    TopBanner
  },
  data() {
    return {
      bgImg: 'fansList',
      mainTitle: '팬존',
      isMobile: true,
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.onResize()
    });
  },
  methods: {
    isEmpty,
    onResize () {
      this.isMobile = window.innerWidth < 960
    },
  },
  computed: {
    currentMenuName() {
      return this.$route.name;
    },
    subTitle() {
      return this.$route.meta.title
    },
    routeName() {
      switch (this.$route.params.page){
        case 'news':
          return '뉴스';
        case 'notice':
          return '공지사항';
        case 'vod':
          return '영상';
        case 'csrnews':
          return 'CSR NEWS';
        case 'cheer':
          return '응원가';
        default :
          return ''
      }
    }
  }
}
</script>
